import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/app/node_modules/next/dist/compiled/@babel/runtime/regenerator";
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { Box, ChevronRight, Container, Link, Section, Text } from '@miro-site/core';
import { Headline } from '@miro-site/components_utils';
import { theme } from '@miro-site/design-tokens';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var IconWrapper = styled(Box).attrs({
  $styles: {
    width: 24,
    height: 24,
    position: 'absolute',
    right: [20, 32],
    top: '50%',
    transform: 'translateY(-50%)',
    'svg path': {
      transition: 'stroke 300ms ease'
    }
  }
}).withConfig({
  displayName: "OpenJobs__IconWrapper",
  componentId: "sc-1kpgrgt-0"
})([""]);
var Items = styled(Box).attrs({
  $mx: [-20, -32]
}).withConfig({
  displayName: "OpenJobs__Items",
  componentId: "sc-1kpgrgt-1"
})([""]); // Todo: Use a generic flex wrapper uitility component instead

var FlexWrapper = styled(Box).withConfig({
  displayName: "OpenJobs__FlexWrapper",
  componentId: "sc-1kpgrgt-2"
})(["display:flex;flex-wrap:wrap;justify-content:space-between;"]);
var JobTitle = styled(Text).withConfig({
  displayName: "OpenJobs__JobTitle",
  componentId: "sc-1kpgrgt-3"
})(["transition:color 300ms ease;"]);
var AlternateShadedRows = styled(Link).attrs({
  $styles: {
    display: 'block',
    '&:nth-child(even)': {
      background: 'workshopGray',
      borderRadius: [0, 8]
    }
  }
}).withConfig({
  displayName: "OpenJobs__AlternateShadedRows",
  componentId: "sc-1kpgrgt-4"
})(["&:hover{", "{", "}", " svg path{", "}}"], JobTitle, function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.colors.primaryBlue
  };
}, IconWrapper, function (_ref2) {
  var theme = _ref2.theme;
  return {
    stroke: theme.colors.primaryBlue
  };
});
var GREENHOUSE_API_ENDPOINT = "https://boards-api.greenhouse.io/v1/boards/realtimeboardglobal";
export var getDepartmentJobsEndpoint = function getDepartmentJobsEndpoint(departmentId) {
  if (departmentId && Number(departmentId)) {
    return "".concat(GREENHOUSE_API_ENDPOINT, "/departments/").concat(departmentId, "/?render_as=tree");
  }

  return "".concat(GREENHOUSE_API_ENDPOINT, "/jobs/?render_as=tree");
};

var useJobs = function useJobs(endpoint, limit) {
  if (!endpoint) {
    return;
  }

  var _useState = useState([]),
      jobs = _useState[0],
      setJobs = _useState[1];

  var _useState2 = useState(true),
      isLoading = _useState2[0],
      setLoading = _useState2[1];

  useEffect(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _response$data, _response$data$childr;

        var response, _jobs;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return axios.get(endpoint)["catch"](function (e) {
                  return e;
                });

              case 2:
                response = _context.sent;
                setLoading(false);

                if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && (_response$data$childr = _response$data.children) !== null && _response$data$childr !== void 0 && _response$data$childr.length) {
                  _jobs = response.data.children.reduce(function (departmentJobs, subDepartment) {
                    return departmentJobs.concat(subDepartment.jobs);
                  }, []);
                  setJobs(_jobs.slice(0, limit || undefined));
                } else {
                  setJobs([]);
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchData() {
        return _ref3.apply(this, arguments);
      };
    }();

    fetchData();
  }, [endpoint, limit]);
  return {
    isLoading: isLoading,
    jobs: jobs
  };
};

var OpenJobs = function OpenJobs(_ref4) {
  var headline = _ref4.headline,
      departmentId = _ref4.departmentId,
      limit = _ref4.limit;

  var _useJobs = useJobs(getDepartmentJobsEndpoint(departmentId), limit),
      isLoading = _useJobs.isLoading,
      jobs = _useJobs.jobs;

  return /*#__PURE__*/_jsx(Section, {
    "data-place": "Open roles",
    type: "medium",
    id: "section-open-jobs",
    children: /*#__PURE__*/_jsxs(Container, {
      children: [(headline === null || headline === void 0 ? void 0 : headline.text) && /*#__PURE__*/_jsx(Headline, _objectSpread({
        size: "mid",
        tag: "h2",
        color: headline.color
      }, headline)), /*#__PURE__*/_jsx(Box, {
        $styles: {
          marginTop: [theme.spaces.xl]
        },
        children: isLoading ? /*#__PURE__*/_jsx(FlexWrapper, {
          children: /*#__PURE__*/_jsx(Text, {
            $variant: "p1",
            children: "Loading..."
          })
        }) : jobs !== null && jobs !== void 0 && jobs.length ? /*#__PURE__*/_jsx(Items, {
          "data-testid": "jobs-list",
          children: jobs.map(function (job) {
            return /*#__PURE__*/_jsx(AlternateShadedRows, {
              href: job.absolute_url,
              children: /*#__PURE__*/_jsxs(FlexWrapper, {
                $pl: [20, 32],
                $pr: [56, 78],
                $py: [32, 24],
                $styles: {
                  flexDirection: ['column', 'row'],
                  alignItems: ['flex-start', 'center'],
                  position: 'relative'
                },
                children: [/*#__PURE__*/_jsxs(FlexWrapper, {
                  $styles: {
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  },
                  children: [/*#__PURE__*/_jsx(Box, {
                    $pr: [null, 32],
                    $styles: {
                      width: ['100%', null],
                      flex: ['0 0 100%', null]
                    },
                    children: /*#__PURE__*/_jsx(JobTitle, {
                      $variant: "p1medium",
                      children: job.title
                    })
                  }), /*#__PURE__*/_jsx(Box, {
                    $styles: {
                      minWidth: [null, 250],
                      marginTop: [8, null]
                    },
                    children: /*#__PURE__*/_jsx(Text, {
                      $variant: "p1",
                      $color: "greyish",
                      children: job.location.name
                    })
                  })]
                }), /*#__PURE__*/_jsx(IconWrapper, {
                  children: /*#__PURE__*/_jsx(ChevronRight, {
                    "aria-hidden": "true",
                    color: theme.colors.primaryIndigo,
                    width: 24,
                    height: 24
                  })
                })]
              })
            }, job.id);
          })
        }) : /*#__PURE__*/_jsx(FlexWrapper, {
          $py: theme.spaces.lg,
          "data-testid": "jobs-list",
          children: /*#__PURE__*/_jsx(Text, {
            $variant: "p1",
            children: "Sorry, we don't have any jobs that match your search right now."
          })
        })
      })]
    })
  });
};

export default OpenJobs;